const Error = () => {
  return (
    <h1 className="text-red-500 flex p-4 text-xxl font-bold items-center justify-center h-screen">
      ERROR OCCURED WHILE FETCHING DATA, API URL IS NOT CORRECT, TRY AGAIN LATER
    </h1>
  );
};

export default Error;
